module.exports = __webpack_public_path__ + "img/story9-GERA-on-tour-2.jpg";